<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    <v-textarea
      :value="form"
      :dense="true"
      :label="block.label"
      outlined
      :disabled="block.disabled"
      hide-details="auto"
      :class="block.inputClass"
      placeholder=" "
      auto-grow
      :rows="block.rows ? block.rows : 1"
      @input="$emit('update:form', $event)"
    />
  </v-col>
</template>

<script>
export default {
   name: 'TextArea',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: String,
         required: true,
      },
   },
}
</script>
<style>
   /* .v-text-field .v-label {
      transform: translateY(-18px) scale(0.75);
      background-color: white;
   } */
</style>
